<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                      'bg-gray-600': sharedService.userTheme === 'dark',
                      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row padding10">
        <h5>Print Lab Licenses</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-col" *ngIf="editMode == 'process'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-700': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <ol>
          <li>Enter state numbers and click the <strong>Verify</strong> button to view which of the labs entered are
            eligible for renewal.</li>
          <li>Enter a date and click the <strong>Verify</strong> button to view all labs licensed on that date.</li>
          <li>Enter nothing and click the <strong>Verify</strong> button to view all labs of the given type which are
            eligible for renewal.</li>
          <li>If state numbers or nothing are entered the verification page will allow you to re-license all the labs
            shown and print their renewal forms.</li>
          <li>If a date is entered the verification page will allow you to print licenses for all labs licensed on the
            date entered.</li>
        </ol>
        <br />
        <span *ngIf="type == 'HST'">Currently filtering to certificate type <strong>T - HST</strong> and lab type
          <strong>10 - Health Fair/Health Screen Testing</strong> </span>
        <span *ngIf="type == 'SOA'">Currently filtering to certificate type <strong>R - Permit</strong> and lab
          type <strong>30 - SOA Registry</strong> </span>
      </mat-card-content>
    </mat-card>
    <form [formGroup]="formGroup">
      <div class="flex flex-row">

        <mat-form-field Style="padding-right:20px">
          <mat-label>Enter State Numbers (optional)</mat-label>
          <textarea matInput cdkTextareaAutosize formControlName="StateNumbers"></textarea>
          <mat-error *ngIf="formGroup.get('StateNumbers').invalid">
            Cannot be longer than 4000 characters.
          </mat-error>
        </mat-form-field>

        <mat-form-field Style="padding-right:20px">
          <mat-label>Enter Re-License Date</mat-label>
          <input matInput [matDatepicker]="LicenseDate" formControlName="LicenseDate">
          <mat-datepicker-toggle matSuffix [for]="LicenseDate"></mat-datepicker-toggle>
          <mat-datepicker #LicenseDate></mat-datepicker>
          <mat-error *ngIf="formGroup.get('LicenseDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>

        <mat-form-field Style="padding-right:20px">
          <mat-label>Lab Type</mat-label>
          <mat-select formControlName="LicenseType" (selectionChange)="typeChange()">
            <mat-option value=""></mat-option>
            <mat-option value="HST">HST</mat-option>
            <mat-option value="SOA">SOA</mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('LicenseType').invalid">
            Required field.
          </mat-error>
        </mat-form-field>

        <div>
          <button type="button" mat-raised-button color="primary" (click)="verify()">Verify</button>
        </div>

      </div>
    </form>
    <div class="flex flex-col">
      <span>
        <small>State #'s may be entered as a range separated by a dash and/or individual State #s separated by
          commas</small>
        <br />
        Example: 101-302,9756,9800-9900,10001
      </span>
    </div>
  </div>


  <!-- List Mode -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-700': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col">
          <div class="flex flex-col">
            <h6>{{type}} Labs to be Re-licensed ({{list.length}})</h6>
            <br /> <br />
            <span>Report Date: {{currentDate}}</span>
            <br />
            <div class="flex flex-row">
              <div class="flex flex-row">
                <ol>
                  <li>The {{type}} labs eligible for renewal can be updated by click the <strong>Print Licenses</strong>
                    button.</li>
                  <li>This will re-license all labs listed below to <strong>{{licenseDate}}</strong>, and print each
                    lab's license.</li>
                </ol>
              </div>

              <div class="float-right">
                <button type="button" mat-raised-button color="primary" (click)="printLicenses()">Print
                  Licenses</button>
              </div>

            </div>
          </div>
          <div class="flex flex-row">
            <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort class="w-full"
                #TableSort="matSort" class="mat-elevation-z8" matSortActive="labName" matSortDirection="asc">
                <ng-container matColumnDef="labName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                  <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                </ng-container>
                <ng-container matColumnDef="stateNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                  <td mat-cell *matCellDef="let item">{{item.stateNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="cliaNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIA Number</th>
                  <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="cashDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Cash Date</th>
                  <td mat-cell *matCellDef="let item">{{item.cashDate}}</td>
                </ng-container>
                <ng-container matColumnDef="expirationDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
                  <td mat-cell *matCellDef="let item">{{item.expirationDate}}</td>
                </ng-container>
                <ng-container matColumnDef="mailingAddress">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Mailing Address</th>
                  <td mat-cell *matCellDef="let item">{{item.mailingAddress}}</td>
                </ng-container>
                <ng-container matColumnDef="mailingCity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                  <td mat-cell *matCellDef="let item">{{item.mailingCity}}</td>
                </ng-container>
                <ng-container matColumnDef="mailingState">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
                  <td mat-cell *matCellDef="let item">{{item.mailingState}}</td>
                </ng-container>
                <ng-container matColumnDef="mailingZip">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
                  <td mat-cell *matCellDef="let item">{{item.mailingZip}}</td>
                </ng-container>
                <ng-container matColumnDef="director">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Director</th>
                  <td mat-cell *matCellDef="let item">{{item.director}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>